// @flow
import * as React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { IAuthResponse, IFreeRoom, ILocationWideResponse, emptyLocationWideResponse, emptyRoom, sxfw, sxfwNarrow } from '../../Interfaces';
import { useSelector } from 'react-redux';
import { Alert, Box, Button, ButtonGroup, CardContent, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField, Typography } from '@mui/material';
import { addOrUpdateFreeRooms, getLocationInfoWide } from '../../Data/ApiRequests';
import CheckIcon from '@mui/icons-material/Check';



export const Freespace = () => {

    const navigate = useNavigate();
    const bearerToken: IAuthResponse = useSelector((state: IAuthResponse) => state)
    const { guid } = useParams();
    const [locationSpace, setLocationSpace] = React.useState<ILocationWideResponse>(emptyLocationWideResponse)
    const [openDialog, setOpenDialog] = React.useState(false);
    const [operationResult, setOperationResult] = React.useState('');
    const [hideButtonNein, setHideButtonNein]= React.useState(false);
    const [equalDialog, setEqaulDialog] = React.useState(false);
    const [sendDisabled, setSendDisabled] = React.useState(true);
    const [firstPartCorrect, setFirstPartCorrect ] = React.useState('')
    const [notEqualDialog, setNotEqaulDialog] = React.useState(false);
    const [isError, setIsError] = React.useState(false);
    const [errorLoadText, setErrorLoadText] = React.useState('') ;
    const [errorOperation, setErrorOperation] = React.useState('');

    const fetchData = async ():Promise<ILocationWideResponse> => {
        return new Promise((resolve, reject) => {
            getLocationInfoWide(guid, bearerToken.token)
            .then(response => {
                if (response.roomspace === null) response.roomspace = emptyRoom
                response.roomspace.wnummer = response.location.wnummer
                response.roomspace.totalSeats = countTotalSeats(response.roomspace)
                setLocationSpace(response)
                setErrorLoadText('')
                //Check if seats are set correctly, needed to check onload
                checkCommonSpace(response)
                setErrorOperation('');
                resolve(response)
            }).catch (error =>  {


                console.error('Error fetching data:', error);
                setErrorLoadText(error);
                setErrorOperation('Error fetching data:' + error)
                reject(false)
            })
        })
    };



    const SaveFreeRooms = async () => {
        addOrUpdateFreeRooms(locationSpace.roomspace, bearerToken.token)
            .then( (response) => {
                if( (response as string).indexOf('status') !== -1) {
                    setIsError(true)
                    setOperationResult('');
                    setErrorOperation('Error on update')
                }
                else {
                    setHideButtonNein(true)
                    setIsError(false)
                    setOperationResult('Vielen Dank für Ihre Meldung. Ihre Angaben wurden übermittelt.');
                    setErrorOperation('')
                }
            }).catch((error) => {
                setIsError(true)

                console.log('err', error)
                setErrorOperation('Error on update')
                setOperationResult('')
            })
        }

    const PreSaveCheck = (): boolean => {
        if(sendDisabled) return false;
        setOperationResult('')
        setErrorOperation('')
        const totalSeats:number = countTotalSeats( locationSpace.roomspace)

        console.log('presave, ', locationSpace.location.capacity, totalSeats)
        if(locationSpace.roomspace.numberOfAvailablePlaces === totalSeats) {
            SaveFreeRooms()
            setEqaulDialog(true)
            return true;
        }
        else  {
            setNotEqaulDialog(true)
            setOperationResult('Achtung! In Ihre Angaben fehlerhaft oder unvollständig. Möchten Sie Ihre Meldung trotzdem abschicken?')
            return true;
        }
    }

    const countTotalSeats = (curFreeRooms: IFreeRoom): number => {
        let summary:number = 0;

        summary =
            //curFreeRooms.singleRoomM  +
            //curFreeRooms.singleRoomW +
            curFreeRooms.singleRoomFMD + curFreeRooms.feedSlotM +
            curFreeRooms.feedSlotW +
            curFreeRooms.roomForTwo * 2 + curFreeRooms.roomForThree * 3 + curFreeRooms.roomForFour * 4 + curFreeRooms.roomForFive * 5 +
            curFreeRooms.roomForSix * 6 + curFreeRooms.roomForSeven * 7 + curFreeRooms.roomForEight * 8 + curFreeRooms.roomForNine * 9 +
            curFreeRooms.roomForTen * 10
            process.env.NODE_ENV==='development' && console.log('cur', curFreeRooms, summary)
            return summary;
    }
    function updateFreeRoomObject <T extends keyof IFreeRoom> (key: T, newValue: string):void {
        const prevLocationSpace = {...locationSpace}
        if (key === 'singleRoomFMD') prevLocationSpace.roomspace.singleRoomFMD = (newValue.trim() === '' || parseInt(newValue.trim()) < 0) ? 0 : parseInt(newValue)
            // prevLocationSpace.roomspace.singleRoomFMD = (isNaN(parseInt(newValue)) || parseInt(newValue) < 0) ? 0 : parseInt(newValue)
        if (key === 'feedSlotW') prevLocationSpace.roomspace.feedSlotW =  (newValue.trim() === '' || parseInt(newValue.trim()) < 0) ? 0 : parseInt(newValue)
        if (key === 'feedSlotM') prevLocationSpace.roomspace.feedSlotM =  (newValue.trim() === '' || parseInt(newValue.trim()) < 0) ? 0 : parseInt(newValue)
        if (key === 'roomForTwo') prevLocationSpace.roomspace.roomForTwo =  (newValue.trim() === '' || parseInt(newValue.trim()) < 0) ? 0 : parseInt(newValue)
        if (key === 'roomForThree') prevLocationSpace.roomspace.roomForThree =  (newValue.trim() === '' || parseInt(newValue.trim()) < 0) ? 0 : parseInt(newValue)
        if (key === 'roomForFour') prevLocationSpace.roomspace.roomForFour = (newValue.trim() === '' || parseInt(newValue.trim()) < 0) ? 0 : parseInt(newValue)
        if (key === 'roomForFive') prevLocationSpace.roomspace.roomForFive = (newValue.trim() === '' || parseInt(newValue.trim()) < 0) ? 0 : parseInt(newValue)
        if (key === 'roomForSix') prevLocationSpace.roomspace.roomForSix = (newValue.trim() === '' || parseInt(newValue.trim()) < 0) ? 0 : parseInt(newValue)
        if (key === 'roomForSeven') prevLocationSpace.roomspace.roomForSeven = (newValue.trim() === '' || parseInt(newValue.trim()) < 0) ? 0 : parseInt(newValue)
        if (key === 'roomForEight') prevLocationSpace.roomspace.roomForEight = (newValue.trim() === '' || parseInt(newValue.trim()) < 0) ? 0 : parseInt(newValue)
        if (key === 'roomForNine') prevLocationSpace.roomspace.roomForNine = (newValue.trim() === '' || parseInt(newValue.trim()) < 0) ? 0 : parseInt(newValue)
        if (key === 'roomForTen') prevLocationSpace.roomspace.roomForTen = (newValue.trim() === '' || parseInt(newValue.trim()) < 0) ? 0 : parseInt(newValue)

        //if (key === 'text_SingleRoomM') prevLocationSpace.roomspace.text_SingleRoomM = newValue.substring(0, 100)
        // if (key === 'text_SingleRoomW') prevLocationSpace.roomspace.text_SingleRoomW  = newValue.substring(0, 100)
        if (key === 'text_SingleRoomFMD') prevLocationSpace.roomspace.text_SingleRoomFMD = newValue.substring(0, 100)
        if (key === 'text_FeedSlotW') prevLocationSpace.roomspace.text_FeedSlotW = newValue.substring(0, 100)
        if (key === 'text_FeedSlotM') prevLocationSpace.roomspace.text_FeedSlotM = newValue.substring(0, 100)
        if (key === 'text_RoomForTwo') prevLocationSpace.roomspace.text_RoomForTwo = newValue.substring(0, 100)
        if (key === 'text_RoomForThree') prevLocationSpace.roomspace.text_RoomForThree = newValue.substring(0, 100)
        if (key === 'text_RoomForFour') prevLocationSpace.roomspace.text_RoomForFour = newValue.substring(0, 100)
        if (key === 'text_RoomForFive') prevLocationSpace.roomspace.text_RoomForFive = newValue.substring(0, 100)
        if (key === 'text_RoomForSix') prevLocationSpace.roomspace.text_RoomForSix = newValue.substring(0, 100)
        if (key === 'text_RoomForSeven') prevLocationSpace.roomspace.text_RoomForSeven = newValue.substring(0, 100)
        if (key === 'text_RoomForEight') prevLocationSpace.roomspace.text_RoomForEight = newValue.substring(0, 100)
        if (key === 'text_RoomForNine') prevLocationSpace.roomspace.text_RoomForNine = newValue.substring(0, 100)
        if (key === 'text_RoomForTen') prevLocationSpace.roomspace.text_RoomForTen = newValue.substring(0, 100)

        if (key === 'notesOnAccommodation') prevLocationSpace.roomspace.notesOnAccommodation = newValue


        prevLocationSpace.roomspace.totalSeats = countTotalSeats( locationSpace.roomspace)
        checkCommonSpace(prevLocationSpace)

        setLocationSpace(prevLocationSpace)
    }
    const changeTextField = (key: string, newValue: string) => {
        const newBuilding:ILocationWideResponse = {...locationSpace}
        // const roomspace : IFreeRoom = { ...locationSpace.roomspace}
        if (key === 'numberOfOccupiedUkr') {
            newBuilding.roomspace.numberOfOccupiedUkr = (newValue.trim() === '' || parseInt(newValue.trim()) < 0) ? 0 : parseInt(newValue)
        }
        if (key === 'numberOfAvailablePlaces') {

            const nv:number = (newValue.trim() === '' || parseInt(newValue.trim()) < 0) ? 0 : parseInt(newValue)
            if(nv === 0) {
                const em: IFreeRoom = { ...newBuilding.roomspace,
                    singleRoomFMD: 0,
                    feedSlotW: 0,
                    feedSlotM: 0,
                    roomForTwo: 0,
                    roomForThree: 0,
                    roomForFour: 0,
                    roomForFive: 0,
                    roomForSix: 0,
                    roomForSeven: 0,
                    roomForEight: 0,
                    roomForNine: 0,
                    roomForTen: 0,
                }
                newBuilding.roomspace = em
            }
            newBuilding.roomspace.numberOfAvailablePlaces = nv
        }
        if (key === 'numberOfOccupiedOru') {
            newBuilding.roomspace.numberOfOccupiedOru = (newValue.trim() === '' || parseInt(newValue.trim()) < 0) ? 0 : parseInt(newValue)
        }

        if (key === 'numberOfReservedSeats') {
            newBuilding.roomspace.numberOfReservedSeats = (newValue.trim() === '' || parseInt(newValue.trim()) < 0) ? 0 : parseInt(newValue)
        }
        if (key === 'numberOfUnoccupiedSeats') {
            //newBuilding.roomspace.numberOfUnoccupiedSeats = (newValue.trim() === '' || parseInt(newValue.trim()) < 0) ? 0 : parseInt(newValue)
            if (newValue.trim() === '' || parseInt(newValue.trim()) < 0) {
                newBuilding.roomspace.numberOfUnoccupiedSeats = 0;
                newBuilding.roomspace.whyNotAssignable = ''
            } else {
                newBuilding.roomspace.numberOfUnoccupiedSeats = parseInt(newValue)
            }
        }
        if (key === 'whyNotAssignable') {
            newBuilding.roomspace.whyNotAssignable = newValue
        }
        newBuilding.roomspace.totalSeats = countTotalSeats(newBuilding.roomspace)
        setLocationSpace(newBuilding)
        checkCommonSpace(newBuilding);
    }

        function TableRowRender2<T extends keyof IFreeRoom>(obj: IFreeRoom, key: T, text_key: T, title: string, multiply: number  ):React.JSX.Element {

            const roomsQuantity: number = obj[key] as number
            const numberOfSeats: number =  (isNaN(roomsQuantity)) ? 0 : roomsQuantity * multiply;
            return (

            <Box sx={{ ...sxfwNarrow, display: 'flex', flexDirection: 'row', flexWrap: 'wrap',
                    alignItems: 'baseline', border: '#CCC 1px solid', borderRadius: '5px', justifyContent: 'space-between'}}>
                <Box sx={{ ...sxfwNarrow, flexGrow: 2 }}>
                <TextField  label={title} variant="outlined"
                 autoComplete='password'
                    disabled={
                        (locationSpace.roomspace.totalSeats >= locationSpace.roomspace?.numberOfAvailablePlaces
                            && obj[key] === 0
                        )
                     }
                    type="text" size='small' sx={{ width: '100%' }}
                    value={obj[key]??0}
                    onChange={(evt) => { updateFreeRoomObject(key, evt.currentTarget.value) }}
                    helperText=''


                    InputLabelProps={{
                        shrink: true,
                    }}
                />
                </Box>
                <Box sx={{...sxfwNarrow, maxWidth: 80}}>
                    <TextField id={`numberOfSeats${obj[key]}`} value={numberOfSeats??0} label='Plätze' size='small' disabled></TextField>
                </Box>
                <Box sx={{ ...sxfwNarrow, flexGrow: 2 }}>
                    <TextField multiline={false} type='text' label='Belegungshinweise' variant='outlined'
                        value={obj[text_key]??''} size='small' sx={{width: '100%', maxHeight: '30px' }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        onChange={(evt) => { updateFreeRoomObject(text_key, evt.currentTarget.value) }} />
                </Box>
            </Box>
            )}


    const checkCommonSpace = async (locSpace: ILocationWideResponse):Promise<void> => {

        if(locSpace.location.capacity === 0)  {
            setSendDisabled(true)
            setFirstPartCorrect('Keine Plätze')
            return;
        }

       if (locSpace.roomspace.numberOfUnoccupiedSeats > 0 &&
                (locSpace.roomspace.whyNotAssignable === null || locSpace.roomspace.whyNotAssignable?.length < 1)) {
                setSendDisabled(true)
                setFirstPartCorrect('Schreiben Sie bitte, warum die Plätze nicht belegbar sind')
                return;
        }


        // SummeDerPlatze is equal to all the entered by user values
        const SummeDerPlatze:number = (locSpace.roomspace.numberOfOccupiedUkr?? 0) + (locSpace.roomspace.numberOfOccupiedOru??0) +
        (locSpace.roomspace.numberOfAvailablePlaces??0) +
        (locSpace.roomspace.numberOfReservedSeats??0) +
        (locSpace.roomspace.numberOfUnoccupiedSeats??0)

        process.env.NODE_ENV === 'development' && console.log(`capacity: ${locSpace.location.capacity}, total seats: ${locSpace.roomspace.totalSeats}, SummeDerPlatze: ${SummeDerPlatze}, numberOfAvailablePlaces: ${locSpace.roomspace.numberOfAvailablePlaces}`)

        if( locSpace.location.capacity === SummeDerPlatze) {
            if(locSpace.roomspace.totalSeats < locSpace.roomspace.numberOfAvailablePlaces)  {
                setSendDisabled(false)
                setFirstPartCorrect(`Sie haben angegeben, dass ${locSpace.roomspace.numberOfAvailablePlaces} belegbare Plätze an Ihrem Standort vorhanden sind. Bitte machen Sie genauere Angaben zu diesen Plätzen`)
            } else if(locSpace.roomspace.totalSeats > locSpace.roomspace.numberOfAvailablePlaces)  {
                    setSendDisabled(true)
                    setFirstPartCorrect(`Sie haben angegeben, dass ${locSpace.roomspace.numberOfAvailablePlaces} belegbare Plätze an Ihrem Standort vorhanden sind. Bitte machen Sie genauere Angaben zu diesen Plätzen`)
            } else if (locSpace.roomspace.totalSeats === locSpace.roomspace.numberOfAvailablePlaces) {
                setSendDisabled(false)
                setFirstPartCorrect(``)
            }
             return;
        }



        if(locSpace.location.capacity > SummeDerPlatze ) {
            setSendDisabled(true)
            setFirstPartCorrect('Bitte machen Sie Angaben zu allen Plätzen')
            return;
        }
        if( locSpace.location.capacity < SummeDerPlatze) {
            setSendDisabled(true)
            setFirstPartCorrect('Ihre Angaben zu den Plätzen entsprechen nicht der vertraglich vereinbarten Platzzahl. Bitte prüfen Sie Ihre Angaben. Nehmen Sie ggf. Kontakt zu Ihrer Ansprechperson bei F&W auf.')
            return;
        }




        if(SummeDerPlatze === locSpace.roomspace.numberOfAvailablePlaces && locSpace.roomspace.numberOfAvailablePlaces > 0)  {
            setSendDisabled(false)
            setFirstPartCorrect(``)
            return;
        }

        // console.log('SummeDerPlatze', SummeDerPlatze, locationSpace.location.capacity, (SummeDerPlatze === locationSpace.location.capacity ))

        if(SummeDerPlatze === locSpace.location.capacity &&
            (SummeDerPlatze !== 0) &&
            (locSpace.roomspace.numberOfAvailablePlaces === 0 || locSpace.roomspace.numberOfAvailablePlaces === undefined) ) {
            setSendDisabled(false)
            setFirstPartCorrect("Sie haben keine belegbare Plätze")
            return;
        }
        // setSendDisabled(false)


        return;
    }

    React.useEffect(() => {
        fetchData().then(response => {
            // console.log('response ',response )
            checkCommonSpace(response)
        }).catch( err => console.log(err))
    }, []);

    return (
        <div>

<CardContent style={{border: '#ccc 1px solid', borderRadius: '10px' }}>
            <h1>Neue Freiplatzmeldung</h1>
        
        <Typography visibility={ (errorLoadText !== '') ? 'visible' : 'hidden'} variant="body2" sx={{ mb: 2, color: 'red' }}>{errorLoadText}</Typography>
        
        <Grid container spacing={0}  className='readonlyBlock'>
            <Grid item xs={11} md={5} lg={5} sx={{ p: 0.3, m: 0.3}}>
                Leitzeichen: {locationSpace.location.wnummer}
                <br />
                Name des Standortes: {locationSpace.location.name}


            </Grid><Grid item xs={11} md={5} lg={5}  sx={{ p: 0.3, m: 0.3}}>
                Standortkategorie: {locationSpace.location.locationCategory}
                <br />
                Soll-Platzzahl (Kapazität):  {locationSpace.location.capacity}
            </Grid>

            <Grid item xs={12}>
                <Box sx={sxfwNarrow}><label className='errorText'>{firstPartCorrect}</label></Box></Grid>
            <Box sx={sxfw}>
                <TextField id="AnzahlBelegterPlatzeUkr" label='Anzahl belegter Plätze (Ukr)' autoComplete='off'
                    variant="outlined" value={locationSpace.roomspace.numberOfOccupiedUkr}
                    type="text" size='small' sx={{ width: '250px' }}
                    onChange={(evt) => {
                        changeTextField('numberOfOccupiedUkr', evt.target.value);
                    }}
                    helperText='Tragen Sie hier ein, wie viele Schutzsuchende aus der Ukraine untergebracht sind.'
                    InputLabelProps={{
                        shrink: true,
                    }}
                    FormHelperTextProps={{ style: {
                        lineHeight: 1.1
                    }  }}
                />

            </Box><Box sx={sxfw}>
                <TextField id="AnzahlBelegtePlatzeOru" label="Anzahl belegte Plätze (örU)" autoComplete='off'
                    variant="outlined" value={locationSpace.roomspace.numberOfOccupiedOru}
                    type="text" size='small' sx={{ width: '250px' }}
                    onChange={(evt) => {
                        changeTextField('numberOfOccupiedOru', evt.target.value);
                    }}
                    helperText='Tragen Sie hier ein, wie viele sonstige Asylsuchende oder andere Klient:innen der örU untergebracht sind.
                    Falls Sie nur Schutzsuchende aus der Ukraine unterbringen, tragen Sie hier eine 0 ein.'
                    FormHelperTextProps={{ style: {
                        lineHeight: 1.1
                    }  }}
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
            </Box><Box sx={sxfw}>
                <TextField id="AnzahlBelegbare Plätze" label="Anzahl belegbare Plätze" autoComplete='off'
                    variant="outlined" value={locationSpace.roomspace?.numberOfAvailablePlaces}
                    type="text" size='small' sx={{ width: '250px' }}
                    onChange={(evt) => {
                        changeTextField('numberOfAvailablePlaces', evt.target.value);
                    }}
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
            </Box><Box sx={sxfw}>
                <TextField id="Anzahl reservierter Plätze" label="Anzahl reservierter Plätze"  autoComplete='off'
                    variant="outlined" value={locationSpace.roomspace.numberOfReservedSeats}
                    type="text" size='small' sx={{ width: '250px' }}
                    onChange={(evt) => {
                        changeTextField('numberOfReservedSeats', evt.target.value);
                    }}
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
            </Box><Box sx={sxfw}>
                <TextField id="Anzahl nicht belegbarer Plätze" label="Anzahl nicht belegbarer Plätze"   autoComplete='off'
                    variant="outlined" value={locationSpace.roomspace.numberOfUnoccupiedSeats}
                    type="text" size='small' sx={{ width: '250px' }}
                    onChange={(evt) => {
                        changeTextField('numberOfUnoccupiedSeats', evt.target.value);
                    }}
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
                <Box sx={{ py: 2}}
        visibility={ (locationSpace.roomspace?.numberOfUnoccupiedSeats === undefined || locationSpace.roomspace.numberOfUnoccupiedSeats === 0) ? 'hidden' : 'visible' }>
                <TextField id="Warum nicht belegbar?"
                    //disabled={locationSpace.roomspace?.numberOfUnoccupiedSeats === undefined || locationSpace.roomspace.numberOfUnoccupiedSeats === 0}
                    label="Warum nicht belegbar?" variant="outlined"
                    value={locationSpace.roomspace.whyNotAssignable??''}
                    type="text" size='small' sx={{ width: '250px' }}
                    onChange={(evt) => {
                        changeTextField('whyNotAssignable', evt.target.value);

                    }}
                    InputLabelProps={{
                        shrink: true,
                    }} />
                </Box>
            </Box>
        </Grid>


            <>

                    {/* <Box display="flex" justifyContent="flex-end" sx={{p: 1, m: 1}}>
                        <Button variant="contained" onClick={() => { navigate(`/locations/${guid}`) }} >Abbrechen</Button>
                        <Box my={1} p={1} />
                        <Button variant="contained"
                            disabled={sendDisabled}
                        onClick={() => { PreSaveCheck() }} >Speichern</Button>
                    </Box> */}

                <CardContent  sx={{p: 0, m: 0}}>
                    <Grid container sx={{p: 1, m: 1}} className='readonlyBlock'>
                            {/* {TableRowRender2(locationSpace.roomspace, 'singleRoomW', 'text_SingleRoomW', 'Einzelzimmer W', 1)} */}
                            {/* {TableRowRender2(locationSpace.roomspace, 'singleRoomM', 'text_SingleRoomM', 'Einzelzimmer M', 1)} */}
                            <Grid item xs={12} md={6} lg={6} >
                            {TableRowRender2(locationSpace.roomspace, 'singleRoomFMD', 'text_SingleRoomFMD', 'Einzelzimmer (w/m/d)', 1)}
                            {TableRowRender2(locationSpace.roomspace, 'feedSlotW', 'text_FeedSlotW', 'Platz in bereits belegtem Zimmer w', 1)}
                            {TableRowRender2(locationSpace.roomspace, 'feedSlotM', 'text_FeedSlotM', 'Platz in bereits belegtem Zimmer m', 1)}
                            {TableRowRender2(locationSpace.roomspace, 'roomForTwo', 'text_RoomForTwo', '2er Zimmer', 2)}
                            {TableRowRender2(locationSpace.roomspace, 'roomForThree', 'text_RoomForThree', '3er Zimmer', 3)}
                            {TableRowRender2(locationSpace.roomspace, 'roomForFour', 'text_RoomForFour', '4er Zimmer', 4)}
                            </Grid>
                            <Grid item xs={12} md={6} lg={6} >
                            {TableRowRender2(locationSpace.roomspace, 'roomForFive', 'text_RoomForFive', '5er Zimmer', 5)}
                            {TableRowRender2(locationSpace.roomspace, 'roomForSix', 'text_RoomForSix', '6er Zimmer', 6)}
                            {TableRowRender2(locationSpace.roomspace, 'roomForSeven', 'text_RoomForSeven', '7er Zimmer', 7)}
                            {TableRowRender2(locationSpace.roomspace, 'roomForEight', 'text_RoomForEight', '8er Zimmer', 8)}
                            {TableRowRender2(locationSpace.roomspace, 'roomForNine', 'text_RoomForNine', '9er Zimmer', 9)}
                            {TableRowRender2(locationSpace.roomspace, 'roomForTen', 'text_RoomForTen', '10er Zimmer', 10)}
                            </Grid>
                        <Grid  item xs={12} md={6} sx={{p: 1, m: 0}}>
                        {/* notesOnAccommodation */}
                        <Box sx={{p: 0, m: 0}}>
                <TextField id="notesOnAccommodation" label={'Allg. Anmerkungen zur Unterbringung'}
                    variant="outlined"  multiline={true} rows={3}
                    type="text" size='small' sx={{ width: '100%' }}
                    value={locationSpace.roomspace.notesOnAccommodation ?? ''}
                    onChange={(evt) => { updateFreeRoomObject('notesOnAccommodation', evt.currentTarget.value) }}
                    helperText=''
                    InputLabelProps={{
                        shrink: true,
                    }}/>
                </Box>
                        </Grid>
                        <Grid item xs={12} md={6} display={'flex'} flexDirection={'row'}  alignContent='end' justifyContent='end'>
                            <Box sx={sxfw}>
                            Summe der gemeldeten Plätze:
                            <span className={ (locationSpace.roomspace.totalSeats > locationSpace.roomspace?.numberOfAvailablePlaces) ? 'errorText normal' : ''}>
                            <b>{locationSpace.roomspace.totalSeats}</b> von <b>{locationSpace.roomspace?.numberOfAvailablePlaces}</b> </span></Box>
                        </Grid>
                    </Grid>

                </CardContent>
                <Box display="flex" justifyContent="flex-end" sx={{p: 1, m: 1}}>
                        <Button variant="contained" onClick={() => { navigate(`/locations/${guid}`) }} >Abbrechen</Button>
                        <Box my={1} p={1} />
                        <Button variant="contained" disabled={sendDisabled}  onClick={() => { PreSaveCheck() }} >Speichern</Button>
                    </Box>

            </>


        </CardContent>

            <Dialog open={openDialog}>
                <DialogTitle></DialogTitle>
                <DialogContent>

                        {`${operationResult}`}

                </DialogContent>
                <DialogActions>

                    <Button onClick={() => {
                        setOpenDialog(false);
                        //navigate(`/locations/${freeSpace.locationId}/freespaces`);
                                    }

                }>Schliessen</Button>
                </DialogActions>

            </Dialog>

            <Dialog open={equalDialog}>
                <DialogTitle></DialogTitle>
                <DialogContent>
                    {
                        (isError) &&
                        <Alert icon={<CheckIcon fontSize="inherit" />} severity="error" className='fwalert'>{errorOperation}</Alert>
                    }
                    {
                        (!isError) &&
                        <Alert icon={<CheckIcon fontSize="inherit" />} severity="success" className='fwalert'>{operationResult}</Alert>
                    }
                </DialogContent>
                <DialogActions>

                    {
                        (errorOperation !== '') &&
                        <Button onClick={() => { SaveFreeRooms() }}>Wiederholen</Button>
                    }

                    <Button onClick={() => { setEqaulDialog(false); navigate(`/locations/`) }}>Schließen</Button>
                </DialogActions>
            </Dialog>


            <Dialog open={notEqualDialog}>
                <DialogTitle></DialogTitle>
                <DialogContent>
                <Alert icon={<CheckIcon fontSize="inherit" />} severity="success">
                    {`${operationResult}`}
                </Alert>
                </DialogContent>
                <DialogActions>

                    {
                        !hideButtonNein &&
                        <ButtonGroup>
                        <Button onClick={() => {
                            SaveFreeRooms();
                        }}>Ja, abschicken</Button>
                        <Button onClick={() => { setNotEqaulDialog(false) }}>Nein, nicht abschicken</Button>
                        </ButtonGroup>
                    }
                    {
                        hideButtonNein &&
                            <Button onClick={() => { setNotEqaulDialog(false); navigate(`/locations/`) }}>Schließen</Button>
                    }



                </DialogActions>

            </Dialog>

        </div>
    );
};